import { createAction, createReducer } from '@reduxjs/toolkit';

import type { State } from './familyLanding.types';

const initialState: State = {
    isLoading: true,
    isLoaded: false,
};

export const loadFamilyLandingRequest = createAction('familyLanding/loadFamilyLandingRequest');
export const loadFamilyLandingSuccess = createAction('familyLanding/loadFamilyLandingSuccess');

export const familyLandingReducer = createReducer(initialState, {
    [loadFamilyLandingRequest.type]: (state) => {
        state.isLoading = true;
        state.isLoaded = false;
    },
    [loadFamilyLandingSuccess.type]: (state) => {
        state.isLoading = false;
        state.isLoaded = true;
    },
});
